import { render, staticRenderFns } from "./CustLand.vue?vue&type=template&id=ba43ec2e&scoped=true"
import script from "./CustLand.vue?vue&type=script&lang=js"
export * from "./CustLand.vue?vue&type=script&lang=js"
import style0 from "./CustLand.vue?vue&type=style&index=0&id=ba43ec2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba43ec2e",
  null
  
)

export default component.exports